import { LOGIN } from './actions'
import {OAuthSession, OAuthToken, User} from 'depoto-core'
// import { User } from 'depoto-core/src/entities'

type UserSession = {
  user: User
  session: OAuthSession
  server: 'prod' | 'stage' | 'dev'
}

export type LoginSliceType = {
  user?: User
  sessions: UserSession[]
  isLoading: boolean
  isLoggedIn: boolean
  lastLoginTime: number
  reloadDataHash: number
  error: string
}
export const initialState: LoginSliceType = {
  user: undefined,
  sessions: [],
  isLoading: false,
  isLoggedIn: false,
  lastLoginTime: 0,
  reloadDataHash: 0,
  error: '',
}

export const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOGIN.INIT:
      return {
        ...state,
        error: '',
        isLoading: true,
      }
    case LOGIN.SUCCESS:
      {
        const sessions = state.sessions?.length ? state.sessions?.filter(s => s.user.email !== action.payload?.user?.email) : []
        sessions.push({
          user: action.payload.user,
          session: action.payload.session,
          server: action.payload.session.clientType,
        })
        return {
          ...state,
          user: action.payload.user,
          sessions,
          isLoading: false,
          isLoggedIn: true,
          lastLoginTime: +new Date(),
        }
      }
    case LOGIN.ERROR:
      return {
        ...state,
        isLoading: false,
        isLoggedIn: false,
        error: action.payload,
      }
    case LOGIN.TERMINATE:
      return {
        ...state,
        user: undefined,
        isLoading: false,
        isLoggedIn: false,
      }
    case LOGIN.LOGOUT:
      return {
        ...state,
        user: undefined,
        isLoading: false,
        isLoggedIn: false,
      }
    default: {
      return state
    }
  }
}
